<template>
  <g stroke="null" fill-rule="evenodd" fill="none">
    <path d="M.112.112h19.776v19.776H.112V.112z" />
    <path
      d="M0.425537 7.2459V14.541H10.2128H20V7.2459V-0.0491797H10.2128H0.425537V7.2459ZM16.383 3.88525V5.68853H14.9149H13.4681L13.3192 6.44262C13.2553 6.86885 13.1915 8.37705 13.1915 9.80328V12.4098H10.3192H7.44681V9.04918V5.68853H5.95745H4.46809V3.88525V2.08197H10.4255H16.383V3.88525Z"
      fill-rule="nonzero"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
